import React, { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { updateWorkStatusWS } from '../../store/actions';
import SweetAlert from 'react-bootstrap-sweetalert';

const PauseWorkstation = function (props) {
  let ws = props.ws;
  const [showAlert, setShowAlert] = useState(false);
  let user = JSON.parse(localStorage.getItem('authUser'));

  const updateWorkStatusWS = (event) => {
    props.updateWorkStatusWS(ws, 1, user.token, props.history);
  };

  const HideAlert = () => {
    setShowAlert(false);
  };

  const pressButton = (event) => {
    setShowAlert(true);
  };

  return (
    <React.Fragment>
      <Button
        className="btn btn-success waves-effect waves-light buttonStatus wsButton"
        onClick={(event) => pressButton(event)}
      >
        {' '}
        <i className="bx bx-play font-size-16 align-middle mr-2"></i> {props.t('Opened')}
      </Button>
      {showAlert && (
        <SweetAlert
          title={props.t('¿Está seguro? ')}
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          cancelBtnText={props.t('cancel')}
          confirmBtnText={props.t('ok')}
          onConfirm={() => updateWorkStatusWS()}
          onCancel={() => HideAlert()}
        >
          {props.t('Vas a pausar esta estación de trabajo,')}
          <br />
          {props.t('si tiene tareas pendientes, no se enviarán.')}
        </SweetAlert>
      )}
    </React.Fragment>
  );
};

const mapStateProps = (state) => {
  const { loadingUpdateWorkStatusWS } = state.updateWorkStatusWS;
  return { loadingUpdateWorkStatusWS };
};

export default withRouter(
  connect(mapStateProps, {
    updateWorkStatusWS,
  })(withNamespaces()(PauseWorkstation))
);
